(() => {
  const finders = new WeakMap();
  const grids = new WeakMap();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const all = (scope, selector) => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  function initializeFeatures(scope) {
    all(scope, '.r-home-feature-grid').forEach(grid => {
      if (grids.has(grid)) return;
      const tabs = [...grid.querySelectorAll('[data-roam-feature-tab]')];
      const panels = [...grid.querySelectorAll('[data-roam-feature-panel]')];
      if (!tabs.length || !panels.length) return;
      let transition;
      function select(tab, focus = false) {
        const update = () => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => panel.hidden = panel.dataset.roamFeaturePanel !== tab.dataset.roamFeatureTab);
          if (focus) tab.focus();
        };
        const panel = panels.find(item => item.dataset.roamFeaturePanel === tab.dataset.roamFeatureTab);
        if (document.startViewTransition && !reduced.matches && document.body.dataset.roamMotion !== 'false' && !window.Shopify?.designMode && grid.dataset.ready === 'true') {
          transition?.skipTransition();
          transition = document.startViewTransition(update);
          transition.ready.catch(() => {});
          transition.finished.catch(() => {});
          transition.updateCallbackDone.catch(() => {});
        } else update();
        if (panel && !reduced.matches && document.body.dataset.roamMotion !== 'false' && !window.Shopify?.designMode) panel.animate([{opacity:.4,transform:'translateY(7px)'},{opacity:1,transform:'translateY(0)'}], {duration:260,easing:'ease-out'});
      }
      grid.classList.add('is-enhanced');
      select(tabs[0]);
      grid.dataset.ready = 'true';
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(tabs[next], true);
        });
      });
      grids.set(grid, {select, tabs});
      grid.closest('[data-roam-home]')?.setAttribute('data-enhanced', 'true');
    });
  }
  function initializeFinder(dialog) {
    if (finders.has(dialog)) return finders.get(dialog);
    if (typeof dialog.showModal !== 'function') return null;
    const steps = [...dialog.querySelectorAll('[data-roam-quiz-step]')];
    const questions = dialog.querySelector('[data-roam-questions]');
    const results = dialog.querySelector('[data-roam-results]');
    const resultCards = [...dialog.querySelectorAll('[data-roam-result]')];
    if (!steps.length || !questions || !results) return null;
    let answers = [];
    let opener;
    function reset() {
      answers = [];
      questions.hidden = false;
      results.hidden = true;
      steps.forEach((step, index) => step.hidden = index !== 0);
      resultCards.forEach(card => card.hidden = true);
    }
    function open(button) {
      opener = button;
      reset();
      if (!dialog.open) dialog.showModal();
      steps[0].querySelector('button')?.focus();
    }
    function close() { dialog.close(); }
    dialog.querySelector('[data-roam-close-finder]')?.addEventListener('click', close);
    dialog.addEventListener('close', () => opener?.focus?.());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    dialog.querySelector('[data-roam-restart]')?.addEventListener('click', () => { reset(); steps[0].querySelector('button')?.focus(); });
    steps.forEach((step, index) => step.querySelectorAll('[data-roam-quiz-choice]').forEach(button => {
      button.addEventListener('click', () => {
        answers[index] = button.dataset.roamQuizChoice;
        if (index + 1 < steps.length) {
          step.hidden = true;
          steps[index + 1].hidden = false;
          steps[index + 1].querySelector('button')?.focus();
        } else {
          const model = answers.filter(answer => answer === 'g9').length >= 2 ? 'g9' : 'g2';
          questions.hidden = true;
          results.hidden = false;
          resultCards.forEach(card => card.hidden = card.dataset.roamResult !== model);
          resultCards.find(card => card.dataset.roamResult === model)?.querySelector('a')?.focus();
          dialog.scrollTop = 0;
        }
      });
    }));
    reset();
    const api = {open, close};
    finders.set(dialog, api);
    dialog.dataset.enhanced = 'true';
    return api;
  }
  function initialize(scope) {
    initializeFeatures(scope);
    all(scope, '[data-roam-finder]').forEach(initializeFinder);
    document.documentElement.classList.toggle('roam-finder-ready', Boolean(document.querySelector('[data-roam-finder][data-enhanced="true"]')));
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-roam-open-finder]');
    if (!trigger) return;
    const dialog = document.querySelector('[data-roam-finder]');
    const finder = dialog && initializeFinder(dialog);
    if (finder) { event.preventDefault(); finder.open(trigger); }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelector('[data-roam-finder][open]')?.close(); requestAnimationFrame(() => initialize(document)); });
  document.addEventListener('shopify:section:select', event => {
    const dialog = event.target.querySelector('[data-roam-finder]');
    if (dialog) initializeFinder(dialog)?.open(event.target);
  });
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details') || event.target.querySelector('details');
    if (details) details.open = true;
    const panel = event.target.closest('[data-roam-feature-panel]');
    const grid = panel?.closest('.r-home-feature-grid');
    if (panel && grid) {
      const controller = grids.get(grid);
      const tab = controller?.tabs.find(item => item.dataset.roamFeatureTab === panel.dataset.roamFeaturePanel);
      if (tab) controller.select(tab);
    }
  });
  initialize(document);
})();
